


















































































































import { Notification, INotification } from "@/entities";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";

const namespace: string = "financialReport";

@Component({
  components: {},
})
export default class DocumentRequestComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Action("updateAuditDocs", { namespace }) updateAuditDocs: any;

  @Prop() requestedDocs: any;
  @Prop() section: string;
  @Prop() subSection: string;
  @Prop() revisionId: number;
  @Prop() grantId: number;
  @Prop() transactionId: number;
  @Prop() documentTags: any;
  @Prop() sectionData: any;
  @Prop() header: any;
  @Prop() items: any;
  @Prop() includeFields: any;
  @Prop() categories: any;

  search: string = "";
  dialog: boolean = false;

  get headers() {
    let docTypeText: string = this.$t("Document type").toString();
    let fields = [];
    let headerInfo: any = [];
    headerInfo.push({
      text: "",
      width: "1%",
      value: "selected",
      class: "selected",
    });

    let filteredItems = this.header.filter((i) =>
      this.includeFields.includes(i.value)
    );
    headerInfo = headerInfo.concat(filteredItems);

    headerInfo.push({
      text: docTypeText,
      width: "50%",
      value: "docType",
      filterable: false,
      class: "",
    });
    headerInfo.push({
      text: "Comments",
      width: "20%",
      value: "comments",
      class: "",
    });

    return headerInfo;
  }

  get rows() {
    let itemInfo: any = [];
    let self = this;
    let reqAuditData = self.financialReport.requestedAuditDocs.find(
      (x) =>
        x.isOpen == 1 &&
        x.grantId == self.grantId &&
        x.transactionId == self.transactionId &&
        x.section_audited == self.section
    );

    self.items.map((row: any) => {
      let auditItem: any = {};

      auditItem.selected = false;
      auditItem.financialReportId = self.transactionId;
      auditItem.itemId = row.rowId;
      auditItem.invoiceNo = row.invoiceNo || null;
      auditItem.docType = [];
      auditItem.comments = "";
      auditItem.section = self.subSection;

      // Include readonly fields from items
      self.includeFields.forEach((key) => {
        if (row.hasOwnProperty(key)) {
          auditItem[key] =
            key == "budgetCategory"
              ? self.categories.find((x) => x.id == row.budgetCategory).name
              : row[key];
        }
      });

      if (reqAuditData) {
        var reqDocTypes = reqAuditData.records.filter(
          (x) => x.section == self.subSection && x.itemId == auditItem.itemId
        );

        if (reqDocTypes && reqDocTypes.length > 0) {
          let docTypes = [];
          reqDocTypes.map((x) => {
            docTypes = docTypes.concat(x.docType[0]);
          });

          if (docTypes.length > 0) {
            auditItem.docType = docTypes;
          }

          auditItem.selected = true;
          auditItem.comments = reqDocTypes[0].comments || "";
        }
      }

      itemInfo.push(auditItem);
    });

    return itemInfo;
  }

  mounted() {}

  sendRequest() {
    let self = this;
    let selectedItems = this.rows.filter((x) => x.selected);
    let auditRequest: any = {};

    // Create audit request object
    auditRequest.revisionId = this.revisionId;
    auditRequest.section_audited = this.section;
    auditRequest.transactionId = this.transactionId;
    auditRequest.grantId = this.grantId;
    auditRequest.records = [];

    selectedItems.forEach((element) => {
      let auditItem: any = {};

      auditItem.id = 1;
      auditItem.itemId = element.itemId;
      auditItem.section = this.subSection;
      auditItem.docType = element.docType;
      auditItem.comments = element.comments;

      let dynamicKeys = Object.keys(this.includeFields);

      dynamicKeys.forEach((x) => {
        auditItem[self.includeFields[x]] = element[self.includeFields[x]];
      });

      auditRequest.records.push(auditItem);
    });

    this.updateAuditDocs({
      auditRequest,
      transactionId: this.transactionId,
      section: this.subSection,
    }).then((data: any) => {
      if (data) {
        this.$store.commit(
          "application/setNotification",
          new Notification({
            snack: true,
            isHtml: true,
            text: this.$t("Saved successfully."),
            color: "success",
          } as INotification),
          { root: true }
        );

        this.dialog = false;

        // Set parent details
        let reqAuditData = self.financialReport.requestedAuditDocs.find(
          (x) =>
            x.isOpen == 1 &&
            x.grantId == this.grantId &&
            x.transactionId == this.transactionId &&
            x.section_audited == this.section
        );

        reqAuditData.records.map((x) => {
          let item = self.items.find((i) => i.rowId == x.itemId);

          if (item) {
            self.includeFields.forEach((key) => {
              x[key] = item[key];
            });
          }
        });
      } else {
        this.$store.commit(
          "application/setNotification",
          new Notification({
            snack: true,
            isHtml: true,
            text: this.$t("Error occurred while saving."),
            color: "error",
          } as INotification),
          { root: true }
        );
      }
    });
  }
}
